import { onMounted, ref } from "vue";

export const useDeviceInformation = () => {
  const isTouchDevice = ref(false);

  onMounted(() => {
    isTouchDevice.value =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
  });

  const isFirefox = computed(() => /firefox/i.test(navigator.userAgent));

  return { isTouchDevice, isFirefox };
};
